import { useRouter } from 'next/router';

import { OnlyForProf, OnlyLoggedIn } from 'components/auth/Redirects';
import Layout from 'components/layout/Layout';
import ProfDashboardPage from 'components/prof/ProfDashboardPage';
import LyceenDashboardPage from 'components/lyceen/LyceenDashboardPage';
import { useIsQuestionnaireComplete, useUser } from 'lib/hooks';
import { useMemoryStore } from 'lib/store';

const AccueilSwitch = () => {
  const { isUserLoading, isProf, isLyceen } = useUser();
  const isquestionnaireComplete = useIsQuestionnaireComplete();
  const router = useRouter();
  const { token } = router.query;
  const setLyceenSignupClasse = useMemoryStore((s) => s.setLyceenSignupClasse);

  if (token) {
    setLyceenSignupClasse({ signupToken: token });
  }

  if (isProf)
    return (
      <OnlyForProf>
        <ProfDashboardPage />
      </OnlyForProf>
    );

  if (isLyceen && isquestionnaireComplete) {
    return <LyceenDashboardPage isUserLoading={isUserLoading} />;
  }
  return null;
};

AccueilSwitch.getWrappers = (page) => (
  <Layout variant="app" rowVariant="gray">
    <OnlyLoggedIn>{page}</OnlyLoggedIn>
  </Layout>
);
export default AccueilSwitch;
